import { render, staticRenderFns } from "./AppLogin.vue?vue&type=template&id=63aaf4c6&scoped=true"
import script from "./AppLogin.vue?vue&type=script&lang=js"
export * from "./AppLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aaf4c6",
  null
  
)

export default component.exports